var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFSettingsCog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 12.787l1.204-2.084-1.664-1.828c.105-.62.1-1.255-.02-1.873l1.633-1.794L14 3.124l-2.4.521a5.654 5.654 0 00-1.67-.947L9.202.42H6.797l-.723 2.27a5.65 5.65 0 00-1.74 1.017l-2.271-.496L.86 5.297l1.579 1.73a5.454 5.454 0 00.019 2.069L.917 10.79l1.203 2.085 2.308-.502c.526.428 1.125.759 1.769.975l.704 2.23h2.406l.74-2.315c.599-.234 1.154-.57 1.641-.991l2.353.514zM8 11.821a3.82 3.82 0 110-7.642 3.82 3.82 0 010 7.642z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F_Settings_Cog.2facd035.svg";
export { SvgFSettingsCog as ReactComponent };